import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitMergeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m10.25 4.5 3.5 3.5-3.5 3.5" }), /* @__PURE__ */ _jsx("path", { d: "M2.25 11.25h2.074a3 3 0 0 0 2.555-1.428L8 8h5M2.25 4.75h2.074a3 3 0 0 1 2.555 1.428L8 8h5" })]
});
export default SvgGitMergeIcon;
